import React from 'react'
import '../Component/css/Vstream.css'
import { useNavigate } from 'react-router-dom'
import header from '../assets/product/vstream/header.webp'
import header2 from '../assets/product/vstream/header2.webp'
import header3 from '../assets/product/vstream/header3.webp'
import header4 from '../assets/product/vstream/header4.webp'
import header4b from '../assets/product/vstream/header4b.webp'
import header5 from '../assets/product/vstream/header5.webp'
import header7 from '../assets/product/vstream/header7.webp'
import header8 from '../assets/product/vstream/header8.webp'
import vstreambg from '../assets/product/vstream/vstreambg.webp'

const Vstream = () => {

    const navigate = useNavigate()
  
    return (
      <div className="about">
        <section className="about-section sec-padding">
          <div className="container">
            <h1 className='projecth1'>Product.</h1>
            <div className="project-row">
            <div className='vstream-project'>

{/* IMAGE BACKGROUND */}
            <img src={vstreambg} alt="background" className='treebg' />

{/* SUMMARY */}
            <div className="vstream-timeline">
                <ul className='vstream-ul'>
                    {/* <li className='vstream-li'><div className="li">Role</div><span> Product Design, Frontend and Backend Development</span></li> */}
                    <li className='vstream-li'><div className="li">Challenge</div><span>The application needs to support users from the age of six(6) and above. The design should be easily navigated by users from different age groups.</span></li>
                    <li className='vstream-li'><div className="li">Sector</div><span>Social Networking | Entertainment | Lifestyle</span></li>
                    <li className='vstream-li'><div className="li">Timeline</div><span>4 Months</span></li>
                </ul>
            </div>

{/* HEADER 1 */}
                <div className="vstream-header-body">
                    <div className="vstream-header-detail">
                        <div className="vstream-header-text-one">
                            <div className="vstream-main-text-one">
                                <h3>About (V stream 2.0)</h3>
                                <div className="vstream-icon">
                                    <i class="fas fa-laptop"></i>
                                    <i class="fas fa-tablet"></i>
                                    <i class="fas fa-desktop"></i>
                                </div> 
                            </div>                             
                            <p>
                            Vstream is a video chat application for connecting with individuals or a group of people who share similar interests. The application features a simple interface, allowing users to interact seamlessly. It was built on the Agora API.The source code is on my <strong><a href="https://github.com/TundeAdekoya/VStream" target="_blank" rel="noopener noreferrer">GitHub Repository</a></strong> and live on <strong><a href="https://vstream-tundeadekoya.vercel.app/" target="_blank" rel="noopener noreferrer">Vercel</a></strong> (Request token to access Vstream's video chat application)
                            </p>  
                        </div> 
                        <div className="vstream-header-image">
                            <img src={header} alt="Vstream headerImage" />
                        </div>                                      
                    </div>
                </div>

{/* HEADER 2 */}
                <div className="Vstream-header2">
                    <div className="Vstream-header2-image">
                        <img src={header2} alt="Vstream header2" />
                    </div>
                </div>

{/* GOAL */}
                <div className="vstream-goal">
                    <div className="vstream-goal-text">
                        <h3>Goal</h3>
                        <p>The goal of this project was to create a video chat application that is user friendly to every age group starting from six(6) and above. The Vstream application can be used for any activity that requires visual interaction with people online.</p>
                    </div>
                </div>
                    <div className="vstream-goal-image">
                        <img src={header4} alt="Vstream Goal" />
                    </div>



{/*  DESIGN PROCESS */}
                    <div className="vstream-design-text">
                        <h3>Design Process</h3>
                        <p>To begin, my research focused on accessibility and functionality of a video chat application. Later, I sketched wireframes and continued to the next phase of the design.</p>
                    </div>

                <div className="vstream-design">
                    <div className="vstream-design-image">
                        <img src={header4b} alt="Vstream Design" />
                    </div>
                </div>



{/*  DEVELOPMENT PROCESS */}
                <div className="vstream-development">
                    <div className="vstream-development-text">
                        <h3>Development Process</h3>
                        <p>To start, I used HTML to structure the position of the video elements and CSS to style the video position and text. Then, I studied the Agora documentation. Lastly, I used Vanilla JavaScript and Agora API to develop the logic for the application.</p>
                    </div>
                </div>
                    <div className="vstream-development-image">
                        <img src={header5} alt="Vstream Development" />
                    </div>
                    <div className="vstream-development-image">
                        <img src={header3} alt="Vstream Development" />
                    </div>



                {/* HEADER 2 1.0 */}

                {/* SCREEN */}
                <div className="Vstream-header5-image">
                    <img src={header8} alt="Vstream header5" />
                </div>


                    <div className="vstream-timeline">
                        <ul className='vstream-ul'>
                            <li className='vstream-li'><div className="li">Role</div><span> Product Design, Frontend and Backend Development</span></li>
                            <li className='vstream-li'><div className="li">Sector</div><span>Social Networking | Entertainment | Lifestyle</span></li>
                            <li className='vstream-li'><div className="li">Timeline</div><span>3 Months</span></li>
                        </ul>
                    </div>

{/* HEADER 1 1.0 */}
                <div className="vstream-header-body">
                    <div className="vstream-header-detail">
                        <div className="vstream-header-text-one">
                            <div className="vstream-main-text-one">
                                <h3>About (V stream 1.0)</h3>
                                <div className="vstream-icon">
                                    <i class="fas fa-laptop"></i>
                                    <i class="fas fa-desktop"></i>
                                </div> 
                            </div>                             
                            <p>
                            Vstream is a streaming platform for learning and connecting people who share common interests. The video chat application features a simple interface to ensure a smooth user experience. The source code is avaliable on my <strong><a href="https://github.com/TundeAdekoya/vStream-react-application" target="_blank" rel="noopener noreferrer">GitHub Repository</a></strong> and live on <strong><a href="https://v-stream-react-application.vercel.app/" target="_blank" rel="noopener noreferrer">Vercel</a></strong></p>                                    
                        </div>
                        <div className="vstream-header-image">
                            <img src={header7} alt="Vstream headerImage" />
                        </div>     
                    </div>
                </div>

{/* ANIMATION */}
        <h2 className='vstream-h2'><span>Thanks for scrolling</span></h2>

        <p className='vstream-p'>Schedule a <a href="https://calendly.com/tunde_dev" target="_blank"  rel="noopener noreferrer">demo call</a> to learn more about this project.</p>
        </div>

{/* End work Detail */}
                    <div onClick={() => navigate('/Portfolio')} className="go_to1">
                                <p>Go back to Portfolio</p> 
                                <div className="icon">
                                    <i class="fas fa-angle-right"></i>
                                    <i class="fas fa-angle-right"></i>
                                </div>
                    </div>       

                   
{/* END */}
            </div>
          </div>
        </section>
    </div>  

    )
}

export default Vstream 